import type { FaireProductEntity } from "../../entity_types/product";

export const p_4sb3cxcgbq: FaireProductEntity = {
  token: "p_4sb3cxcgbq",
  type: "product",
  name: "7-Day Bone Broth Diet Plan",
  brandToken: "b_14eeavl3ro",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/0afbe168ce9b5c32669fa4cfcffa75a7708177c5f8bd7d6cd6108f779da58163.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.77,
  description:
    "Take weight off fast with the nutrient dense cleanse from The 7-Day Bone Broth Diet Plan. \rBone broth diets have been praised by The New York Times and ABC News as an effective way of losing weight without losing the essential vitamins and minerals your body needs. In The 7-Day Bone Broth Diet Plan, co-founder and CEO of the all-natural bone broth company Osso Good, Meredith Cochran, combines flavorful bone broth recipes with an actionable one-week plan to slim down and boost your immune system. Paving the way to lasting weight loss and long-term wellness, The 7-Day Bone Broth Diet Plan equips you with a gut-healing, waist-trimming plan for feeling good. \rThe 7-Day Bone Broth Diet Plan offers:  A One-Week Meal Plan helping you start and stay on track from breakfast until dinner with an easy-to-follow routine\r 25 Flavorful Bone Broth Recipes providing simple-to-follow recipes designed for your stove top, slow cooker, or electric pressure cooker\r 75 Bonus Bone Broth Recipes making sure y",
  tags: [],
  msrpDollars: 23.54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:27.250Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
